<div class="suggestion-popup">
  <div class="suggestion-popup-header">
    <span class="suggestion-popup-title">{{ 'EDITOR.TRACK_CHANGES.POPUP_HEADER' | translate }}</span>
    @if (canResolve) {
      <button
        mat-icon-button
        type="button"
        class="suggestion-action-button"
        [matTooltip]="'EDITOR.TRACK_CHANGES.ACCEPT' | translate"
        [attr.aria-label]="'EDITOR.TRACK_CHANGES.ACCEPT' | translate"
        (click)="onAccept()"
      >
        <mat-icon>check</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        class="suggestion-action-button"
        [matTooltip]="'EDITOR.TRACK_CHANGES.REJECT' | translate"
        [attr.aria-label]="'EDITOR.TRACK_CHANGES.REJECT' | translate"
        (click)="onReject()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
  <div class="suggestion-popup-author">{{ authorName }}</div>
  <div class="suggestion-popup-body">
    @if (hasInsertion && hasDeletion) {
      <span class="suggestion-popup-label">{{ 'EDITOR.TRACK_CHANGES.REPLACED' | translate }}</span>
      @for (run of deletionRuns; track $index) {
        <span
          class="suggestion-popup-deletion"
          [class.suggestion-run-bold]="run.marks.includes('strong')"
          [class.suggestion-run-italic]="run.marks.includes('italic')"
          >{{ run.text }}</span
        >
      }
      <span class="suggestion-popup-label">{{ 'EDITOR.TRACK_CHANGES.WITH' | translate }}</span>
      @for (run of insertionRuns; track $index) {
        <span
          class="suggestion-popup-insertion"
          [class.suggestion-run-bold]="run.marks.includes('strong')"
          [class.suggestion-run-italic]="run.marks.includes('italic')"
          >{{ run.text }}</span
        >
      }
    } @else if (hasInsertion) {
      <span class="suggestion-popup-label">{{ 'EDITOR.TRACK_CHANGES.ADDED' | translate }}:</span>
      @for (run of insertionRuns; track $index) {
        <span
          class="suggestion-popup-insertion"
          [class.suggestion-run-bold]="run.marks.includes('strong')"
          [class.suggestion-run-italic]="run.marks.includes('italic')"
          >{{ run.text }}</span
        >
      }
    } @else if (hasDeletion) {
      <span class="suggestion-popup-label">{{ 'EDITOR.TRACK_CHANGES.REMOVED' | translate }}:</span>
      @for (run of deletionRuns; track $index) {
        <span
          class="suggestion-popup-deletion"
          [class.suggestion-run-bold]="run.marks.includes('strong')"
          [class.suggestion-run-italic]="run.marks.includes('italic')"
          >{{ run.text }}</span
        >
      }
    } @else if (hasFormatting) {
      <span class="suggestion-popup-label">{{ 'EDITOR.TRACK_CHANGES.FORMATTED' | translate }}:</span>
      <span class="suggestion-popup-formatting">{{ formattingLabels.join(', ') }}</span>
    }
    @if (hasListChanges) {
      <div class="suggestion-popup-list-changes">
        <span class="suggestion-popup-label">{{ 'EDITOR.TRACK_CHANGES.STRUCTURE' | translate }}: </span>
        <span class="suggestion-popup-formatting">{{ listChangeLabels.join(', ') }}</span>
      </div>
    }
  </div>
</div>
